import './index.scss';
import React, { Component } from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Checkbox, InputNumber } from 'antd';
import ColorPicker from '../../Watermark/ColorPicker';
import intl from 'react-intl-universal';
import {store} from 'Store/store.index';

const { Item } = Form;
export default class Editing extends Component {
    static storageKey () {
        return 'EDITING_DATA';
    }
    constructor(props) {
        super(props);
        const { showChange, color, indentUnit, alert, recognize } = this.getStorageData();
        this.state = {
            showChange,
            color,
            indentUnit,
            alert,
            recognize
        };
    }
    getStorageData = () => {
        const key = Editing.storageKey();
        let data = localStorage.getItem(key);
        if (data) {
            data = JSON.parse(data);
        } else {
            data = {};
        }
        return Object.assign(store.appStore.preferencesDefaultData.EditingDefaultData, data);
    }
    save = () => {
        const key = Editing.storageKey();
        const data = JSON.stringify(this.state);
        localStorage.setItem(key, data);
    }
    onChangeFacingPages = (key, val) => {
        this.setState({ [key]: val });
    }
    openScannedDocumentSetting = () => {
        store.appStore.showScannedDocumentSetting();
    }
    render() {
        const {
            showChange,
            color,
            indentUnit,
            alert,
            recognize
        } = this.state;
        const Editing = intl.formatMessage({ id: 'Preferences.Content.Editing' });
        const ShowChanged = intl.formatMessage({ id: 'Preferences.Content.editing.Editing.ShowChanged' });
        const Indent = intl.formatMessage({ id: 'Preferences.Content.editing.Editing.Indent' });
        const Unit = intl.formatMessage({ id: 'Preferences.Content.editing.Editing.Unit' });
        const EditingScanned = intl.formatMessage({ id: 'Preferences.Content.editing.EditingScanned.Title' });
        const Alert = intl.formatMessage({ id: 'Preferences.Content.editing.EditingScanned.Alert' });
        const Recognize = intl.formatMessage({ id: 'Preferences.Content.editing.EditingScanned.Recognize' });
        const ScannedDocument = intl.formatMessage({ id: 'Preferences.Content.editing.EditingScanned.ScannedDocument' });
        return (
            <div className="preferences-editing">
                <Form name="editing" size='small' labelCol={{ span: 9 }} wrapperCol={{ offset: 1 }}>
                    <div className="title hide">{Editing}</div>
                    <div className="board LayoutGrid hide">
                        <Item name="customFacingName" className="custom-item" label={
                            <Checkbox className="custom-label" checked={showChange} onChange={(value)=>{this.onChangeFacingPages('showChange',value.target.checked)}}>{ShowChanged}</Checkbox>
                        }>
                            <ColorPicker PickerStyle={{ top: '30px' }} color={color} onChangeComplete={(value)=>{this.onChangeFacingPages('color',value.color)}} />
                        </Item>
                        <Item name="customFacingName" className="custom-item" label={Indent}>
                            <InputNumber className="custom-input" defaultValue={indentUnit} min={0} max={20} step={0.1} onChange={(value)=>{this.onChangeFacingPages('indentUnit',value)}} />
                            <span className="suffix">{Unit}</span>
                        </Item>
                    </div>

                    <div className="title">{EditingScanned}</div>
                    <div className="board LayoutGrid">
                        <Item name="customFacingName" className="custom-item" wrapperCol={{ offset: 0 }}>
                            <Checkbox className="custom-label" checked={alert} onChange={(value)=>{this.onChangeFacingPages('alert',value.target.checked)}}>{Alert}</Checkbox>
                        </Item>
                        <Item name="customFacingName" className="custom-item" wrapperCol={{ offset: 0 }}>
                            <Checkbox className="custom-label" checked={recognize} onChange={(value)=>{this.onChangeFacingPages('recognize',value.target.checked)}}>{Recognize}</Checkbox>
                        </Item>
                        <Item name="customFacingName" className="custom-item" wrapperCol={{ offset: 0 }}>
                            <Button onClick={this.openScannedDocumentSetting}>{ScannedDocument}</Button>
                        </Item>
                    </div>
                </Form>
            </div>
        );
    }
}